import logo from '../../../assets/images/Logo.svg';

export default function Title() {
  return (
    <div className="loginTitle">
      <div className="labelTitle">
        <div>
                Relacione os itens abaixo
        </div>
        <div className="subtitle">
                Informe qual o código dos itens para que o resultado da roteirização seja disponibilizado.
        </div>
      </div>
      <img src={logo} alt="logo" className="logo" />
    </div>
  );
}
